const Fotter = () => {
  return (
    <>
      <footer className="page_footer">
        <div className="footer_text">
          <p>Terms</p>
          <p>Contact Us</p>
          <p>Your Account</p>
        </div>
        <div className="footer_link_div">
          <a href="https://github.com/NamrataRaikwar2002" className="footer_link">
            <i className="fa-brands fa-github fotter_icon"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/namrata-raikwar-727951224/"
            className="footer_link"
          >
            <i className="fa-brands fa-linkedin fotter_icon"></i>
          </a>
          <a
            href="https://twitter.com/RaikwarNamrata?t=plsVpPoUgAtlfzgO6Uvvsw&s=03"
            className="footer_link"
          >
            <i className="fa-brands fa-twitter-square fotter_icon"></i>
          </a>
        </div>
      </footer>
    </>
  )
}

export { Fotter }
